import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { store } from "./store";
import App from "./App";
import Loader from "./containers/loader/Loader";
import { SnackbarProvider } from "notistack";
import "./assets/scss/style.scss";

ReactDOM.render(
  <React.Fragment>
    <ReduxProvider store={store}>
      <Suspense fallback={<Loader />}>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Router>
            <App />
          </Router>
        </SnackbarProvider>
      </Suspense>
    </ReduxProvider>
  </React.Fragment>,
  document.getElementById("root")
);
